import { ActionButtonType } from '../../_components/TaskCard/types';

export const getOfflineAvatarHistoryActionList = ({
  restricted,
  canSubmit,
}: {
  restricted: boolean;
  canSubmit: boolean;
}): ActionButtonType[] =>
  restricted
    ? [ActionButtonType.DOWNLOAD, ActionButtonType.SHARE]
    : [
        ...(canSubmit ? [ActionButtonType.SUBMIT] : []),
        ActionButtonType.DOWNLOAD,
        ActionButtonType.SHARE,
        ActionButtonType.ELLIPSIS_MENU,
        ActionButtonType.STAR,
      ];
